import { render } from "./MarketPlaceBanner.vue?vue&type=template&id=63f0f59e"
import script from "./MarketPlaceBanner.vue?vue&type=script&lang=js"
export * from "./MarketPlaceBanner.vue?vue&type=script&lang=js"

import "./MarketPlaceBanner.vue?vue&type=style&index=0&id=63f0f59e&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__